module.exports = __webpack_public_path__ + "doctor_9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_9.jpg
// module id = 896
// module chunks = 0